export enum ChappAccountTypes {
    ChappProvider = 'CHAPP Provider',
    SpecialtyProgramClinician = 'Specialty Program Clinician',
    SpecialtyProgramProviderAdmin = 'Specialty Program Provider Admin',
}